// CON-1754. Coming back to the Connections list on the phone layout puts the
// list back at the offset it was left at, then makes sure the conversation
// just visited is on screen. A reply that arrived while it was open re-sorts
// the list, so the saved offset alone can land on different rows.
//
// All positions are viewport pixels from getBoundingClientRect. topInset is
// the height of the sticky Show connects row, which covers the top of the
// scroller. A row that is even partly visible counts as on screen and is left
// alone. Returns the scrollTop that reveals the row, or null for no change.
export const getScrollTopToRevealRow = ({
  scrollTop,
  containerTop,
  containerBottom,
  rowTop,
  rowBottom,
  topInset = 0,
}) => {
  const visibleTop = containerTop + topInset;

  if (rowBottom <= visibleTop) {
    return Math.max(0, scrollTop - (visibleTop - rowTop));
  }

  if (rowTop >= containerBottom) {
    return scrollTop + (rowBottom - containerBottom);
  }

  return null;
};

export default getScrollTopToRevealRow;
